<template>
	<button class="error__button" type="button" title="Ошибка, см. подробнее">
		<svg viewBox="0 0 47.319 227.929" xmlns="http://www.w3.org/2000/svg">
			<g transform="translate(-232.65 -173)">
				<path d="m256.15 173c-12.68 0-22.576 6.8-22.576 18.866 0 36.8 4.329 89.686 4.329 126.49 0 9.587 8.352 13.607 18.248 13.607 7.422 0 17.937-4.02 17.937-13.607 0-36.8 4.329-89.686 4.329-126.49 0-12.061-10.205-18.866-22.267-18.866z"/>
				<path d="m256.46 353.31a23.814 23.814 0 0 0 0 47.628c12.68 0 23.505-11.134 23.505-23.814 0-12.99-10.826-23.814-23.505-23.814z"/>
			</g>
		</svg>
	</button>
</template>

<script>
import tooltip from '../../components/Tooltip.vue'

export default {
	components: {
		tooltip
	},
	data() {
		return {
		}
	},
}
</script>


<style lang="scss" scoped>
@import './../../styles/variables.scss';
.error {
	position: relative;
	width: 25px;
	height: 25px;

	&__button {
	position: relative;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	color: white;
	font-size: 18px;
	min-width: 25px;
	height: 25px;
	border: none;
	border-radius: 50%;
	background-color: #cf3849;
	box-shadow: 0px 5px 10px -1px rgba(0, 0, 0, 0.25);
	transition: all 200ms;
	outline: none;
	cursor: default;

	svg {
		width: 15px;
		height: 15px;
		fill: $bg-grey;
	}
	}


}
</style>
